import React from "react";
import "./TableHistoryPPIC.css";

const TableHistoryPPIC = ({ data, jenisBahan, satuan }) => {
  const unit = jenisBahan === "BAKU" ? "Kg" : "Pcs";

  const renderMaterial = (obj) =>
    Array.isArray(obj.material) ? (
      <div className="thp_stack">
        {obj.material.map((el, i) => (
          <span key={i}>{el.material}</span>
        ))}
      </div>
    ) : (
      obj.material
    );

  const renderTotal = (obj) => {
    if (jenisBahan === "SATUAN") {
      return `${obj.total} Pcs`;
    }
    if (obj.totalBahan) {
      return Array.isArray(obj.material) ? (
        <div className="thp_stack">
          {obj.material.map((el, i) => (
            <span key={i}>
              {el.perbandingan * obj.totalBahan} {unit}
            </span>
          ))}
        </div>
      ) : (
        `${obj.totalBahan} ${unit}`
      );
    }
    return Array.isArray(obj.material) ? (
      <div className="thp_stack">
        {obj.material.map((el, i) => (
          <span key={i}>
            {el.total} {unit}
          </span>
        ))}
      </div>
    ) : (
      `${obj.total} ${unit}`
    );
  };

  const rows = data ? data.filter((obj) => !obj.isProduksi) : [];

  return (
    <div className="thp_root">
      <div className="thp_scroll">
        <table className="thp_table">
          <thead>
            <tr>
              <th>Mc</th>
              <th>Cust</th>
              <th>Produk</th>
              <th>Bahan</th>
              <th>Color</th>
              <th>Total</th>
            </tr>
          </thead>
          <tbody>
            {rows.length > 0 ? (
              rows.map((obj, index) => (
                <tr key={index}>
                  <td className="thp_cell_mc">{obj.mesin}</td>
                  <td>{obj.customer}</td>
                  <td>{obj.moldType}</td>
                  <td>{renderMaterial(obj)}</td>
                  <td>{obj.color}</td>
                  <td className="thp_cell_num">{renderTotal(obj)}</td>
                </tr>
              ))
            ) : (
              <tr>
                <td className="thp_empty" colSpan={6}>
                  Belum ada data.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};
export default TableHistoryPPIC;
